/**
 * THE SIDEBAR'S ICONS - one per destination, the prototype's own Lucide picks where it draws the
 * same screen (`moonx-authors-prototype/MoonX App.dc.html`, `CAB_NAV`: layout-grid, layers,
 * chart-line, wallet, calendar-days, user, circle-help), and the nearest Lucide icon for the
 * screens it does not draw: Notifications, Settings, and the Inbox (design 24, T17), which holds
 * the two it drew as messages-square and mail.
 *
 * Keyed by the entry's ADDRESS, not its label, so a renamed entry keeps its icon and a new one
 * simply has none until it is given one - the entry still renders, with its words. The icon is
 * decoration beside those words (`aria-hidden`); the entry's name is never the icon.
 *
 * Kept out of ./cabinet-navigation.ts, whose lines other files cite by number.
 */
import {
  CalendarDays,
  ChartLine,
  CircleHelp,
  Inbox,
  Layers,
  LayoutGrid,
  Settings,
  User,
  Wallet,
} from '@moonx/ui';
import type { LucideIcon } from '@moonx/ui';

const ICON_BY_PATH: ReadonlyMap<string, LucideIcon> = new Map<string, LucideIcon>([
  ['/dashboard', LayoutGrid],
  ['/articles', Layers],
  ['/articles/statistics', ChartLine],
  ['/inbox', Inbox],
  ['/payments', Wallet],
  ['/calendar', CalendarDays],
  ['/settings', Settings],
  ['/apply', User],
  ['/support', CircleHelp],
]);

/** The icon for a sidebar entry's address, or `undefined` for an address that has none yet. */
export function navIconFor(path: string): LucideIcon | undefined {
  return ICON_BY_PATH.get(path);
}
